<template>
  <v-container fluid>
    <v-card elevation="0">
      <v-card-title class="secondary--text font-weight-medium pt-5">
        <v-row no-gutters>
          <v-col cols="12">
            <h3 class="my-2 mx-2 primary--text">
              {{ $t("layout.properties") }}
            </h3>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters align="" justify="end">
          <v-col cols="6" class="mr-4">
            <div class="d-flex" style="gap: 10px">
              <v-autocomplete
                clearable
                :loading="$apollo.queries.getLandlords.loading"
                :items="landlordLists"
                :search-input.sync="landlordSearchKey"
                item-value="_id"
                item-text="user.firstName"
                v-model="selectedLandlordId"
                outlined
                dense
              >
                <template #label>
                  <span class="placeholder_as_label">{{
                    $t("landlord.searchLandlord")
                  }}</span>
                </template>
              </v-autocomplete>
              <v-autocomplete
                clearable
                :loading="$apollo.queries.getPropertyByLandlordForAdmin.loading"
                :items="properties"
                :search-input.sync="propertySearchKey"
                item-value="nameEn"
                item-text="nameEn"
                :key="selectedLandlordId"
                v-model="selectedPropertyName"
                outlined
                dense
              >
                <template #label>
                  <span class="placeholder_as_label">{{
                    $t("landlord.searchProperty")
                  }}</span>
                </template>
              </v-autocomplete>
            </div>
          </v-col>
          <v-btn
            @click="addOrEditProperty"
            :class="$vuetify.breakpoint.smAndUp ? 'rounded-lg' : 'my-2 mx-2'"
            class="white--text"
            color="primary"
          >
            {{ $t("landlord.addProperty") }}
          </v-btn>
        </v-row>
        <!-- <div id="wrapper2">
        <div id="top-scroll" class="width-scroll-top"></div>
      </div> -->
        <v-data-table
          class="table-reference-for-scroll"
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          mobile-breakpoint
          :loading="$apollo.queries.getProperties.loading"
          :search="''"
          :headers="propertyHeaders"
          :options="options"
          :items="properties"
          tab="property"
          item-key="_id"
          show-expand
          single-expand
          :server-items-length="totalPropertiesCount"
          @item-expanded="setCurrentLandlordForUnitOperation"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <UnitTable :propertyId="item._id" :key="item._id" />
            </td>
          </template>
          <template v-slot:[`item._id`]="{ item }">
            {{ properties.indexOf(item) + 1 }}
          </template>
          <template v-slot:[`item.helthHygeineEn`]="{ item }">
            <span v-html="item.helthHygeineEn"></span>
          </template>
          <template v-slot:[`item.helthHygeineAr`]="{ item }">
            <div v-html="item.helthHygeineAr"></div>
          </template>
          <template v-slot:[`item.policyEn`]="{ item }">
            <span v-html="item.policiesEn"></span>
          </template>
          <template v-slot:[`item.policyAr`]="{ item }">
            <span v-html="item.policiesAr"></span>
          </template>
          <template #item.landlordValue="{ item }">
            <span v-if="item.landlord.user">
              {{
                `${item.landlord.user.firstName} ${item.landlord.user.lastName}`
              }}
            </span>
          </template>
          <template #item.isActive="{ item }">
            <PropertyDisableDialog
              isProperty
              :id="item._id"
              :status="item.isActive"
              :disabled="false"
            />
          </template>
          <template #item.edit="{ item }">
            <v-btn
              icon
              color="primary"
              @click="
                addOrEditProperty({
                  inputDrawer: true,
                  isEdit: true,
                  propertyId: item._id
                })
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <side-drawer :inputDrawer="inputDrawer">
        <template slot="formDetails">
          <CreateAndEditProperty
            v-if="propertyCreateOrEditMode"
            @refetchProperties="refetchProperties"
            :key="editPropertyProps.propertyId"
            :manualLandlordSelection="!editPropertyProps.isEdit"
            v-bind="{
              ...editPropertyProps
            }"
          />
          <AddUnit
            :key="formRerender"
            v-bind="editUnitProps"
            v-else-if="unitCreateMode"
          />
          <EditUnit
            v-else-if="unitEditMode"
            v-bind="editUnitProps"
            :key="editUnitProps.unitId"
          />
        </template>
      </side-drawer>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {
    // "add-button": () => import("@/core/components/AddButton.vue"),
    "side-drawer": () => import("@/core/components/PropertySideDrawer"),
    CreateAndEditProperty: () =>
      import("@/landlord/components/rightSideDrawer/CreateAndEditProperty.vue"),
    UnitTable: () => import("@/landlord/components/UnitTable.vue"),
    PropertyDisableDialog: () =>
      import("@/landlord/components/DisableDialog.vue"),
    AddUnit: () => import("@/landlord/components/rightSideDrawer/AddUnit.vue"),
    EditUnit: () => import("@/landlord/components/rightSideDrawer/EditUnit.vue")
  },
  data() {
    return {
      options: {
        itemsPerPage: 50,
        page: 1
      },
      editPropertyProps: {
        propertyId: null
      },
      formRerender: 0,
      propertyDetails: [],
      landlordLists: [],
      totalPropertiesCount: 0,
      landlordSearchKey: null,
      propertySearchKey: null,
      propertyCreateOrEditMode: false,
      unitCreateMode: false,
      unitEditMode: false,
      selectedLandlordId: null,
      selectedPropertyName: null,
      editUnitProps: {},
      currentLandlordForUnitOperation: null,
      properties: [],
      inputDrawer: false
    };
  },

  created() {
    this.$root.$on("refetchUnits", () => {
      this.inputDrawer = false;
    });
    this.$root.$on("refetchUnits", () => {
      this.formRerender += 1;
    });
    this.$root.$on("unitChange", ({ isEditUnit, unitId, propertyId }) => {
      this.propertyCreateOrEditMode = false;
      this.editUnitProps = {
        landlordId: this.currentLandlordForUnitOperation._id,
        totalNumberOfUnitsAllowed: this.currentLandlordForUnitOperation
          .validityPlan.numberOfUnits,
        propertyId: propertyId
      };
      if (isEditUnit) {
        this.inputDrawer = true;
        this.editUnitProps = {
          ...this.editUnitProps,
          ...{ unitId: unitId }
        };
        this.unitEditMode = true;
        this.unitCreateMode = false;
      } else {
        this.inputDrawer = true;
        this.editUnitProps = {
          ...this.editUnitProps
        };
        this.unitEditMode = false;
        this.unitCreateMode = true;
        this.formRerender = this.formRerender + 1;
      }
      // this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    });
  },
  watch: {
    landlordSearchKey(val) {
      if (!val) {
        this.refetchProperties();
      }
    },
    selectedPropertyName(val) {
      if (!val) {
        this.selectedLandlordId = null;
      }
      this.refetchProperties();
    }
  },
  computed: {
    propertyHeaders() {
      return [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "_id",
          width: 10
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.en")})`,
          align: "left",
          sortable: false,
          value: "nameEn",
          width: 100
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.ar")})`,
          align: "left",
          sortable: false,
          value: "nameAr",
          width: 100
        },
        {
          text: this.$t("landlord.landlord"),
          align: "left",
          sortable: false,
          value: "landlordValue",
          width: 100
        },
        {
          text: this.$t("landlord.propertyType"),
          align: "left",
          sortable: false,
          value: "propertyType.nameEn",
          width: 100
        },
        {
          text: this.$t("landlord.isActive"),
          align: "center",
          sortable: false,
          value: "isActive",
          width: 100
        },
        // {
        //   text: `${this.$t("property.property.healthHygeine")} (${this.$t(
        //     "common.en"
        //   )})`,
        //   align: "left",
        //   sortable: false,
        //   value: "helthHygeineEn",
        //   width: 100,
        // },
        // {
        //   text: `${this.$t("property.property.healthHygeine")} (${this.$t(
        //     "common.ar"
        //   )})`,
        //   align: "left",
        //   sortable: false,
        //   value: "helthHygeineAr",
        //   width: 100,
        // },
        // {
        //   text: `${this.$t("property.property.description")} (${this.$t(
        //     "common.en"
        //   )})`,
        //   align: "left",
        //   sortable: false,
        //   value: "descriptionEn",
        //   width: 100,
        // },
        // {
        //   text: `${this.$t("property.property.description")} (${this.$t(
        //     "common.ar"
        //   )})`,
        //   align: "left",
        //   sortable: false,
        //   value: "descriptionAr",
        //   width: 100,
        // },
        // {
        //   text: `${this.$t("property.property.policies")} (${this.$t(
        //     "common.en"
        //   )})`,
        //   align: "left",
        //   sortable: false,
        //   value: "policyEn",
        //   width: 100,
        // },
        // {
        //   text: `${this.$t("property.property.policies")} (${this.$t(
        //     "common.ar"
        //   )})`,
        //   align: "left",
        //   sortable: false,
        //   value: "policyAr",
        //   width: 100,
        // },
        {
          text: "Edit Property",
          align: "left",
          sortable: false,
          value: "edit",
          width: 100
        }
      ].map(header => {
        header.align = "center";
        return header;
      });
    }
  },
  mounted() {
    let wrapper_1 = document.querySelector(
      ".table-reference-for-scroll .v-data-table__wrapper"
    );
    let wrapper_2 = document.querySelector("#wrapper2");
    wrapper_1.onscroll = function() {
      wrapper_2.scrollLeft = wrapper_1.scrollLeft;
    };

    wrapper_2.onscroll = function() {
      wrapper_1.scrollLeft = wrapper_2.scrollLeft;
    };
  },
  methods: {
    setCurrentLandlordForUnitOperation({ item }) {
      this.currentLandlordForUnitOperation = item.landlord;
    },
    refetchProperties() {
      this.inputDrawer = false;
      this.$apollo.queries.getProperties.refetch({
        input: {
          limit: 0,
          skip: 0
        },
        filter: {
          searchKey: this.selectedPropertyName ? this.selectedPropertyName : ""
        }
      });
    },
    addOrEditProperty({ isEdit, propertyId }) {
      if (isEdit) {
        this.inputDrawer = true;
        this.editPropertyProps = {
          propertyId: propertyId,
          isEdit: true
        };
      } else {
        this.inputDrawer = true;
        this.editPropertyProps = {
          propertyId: "",
          isEdit: false
        };
      }
      this.propertyCreateOrEditMode = true;
      // this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  },
  apollo: {
    getLandlords() {
      this.loading = true;
      return {
        query: require("@/landlord/api/queries/landlord_query.graphql"),
        variables: () => {
          return {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: this.landlordSearchKey,
              sortBy: "",
              sortDesc: false
            }
          };
        },
        result({ data }) {
          this.landlordLists = data.getLandlords.landlords;
        }
      };
    },
    getPropertyByLandlordForAdmin() {
      return {
        query: require("@/landlord/api/queries/property_query.graphql"),
        fetchPolicy: "no-cache",
        variables: () => ({
          input: {
            limit: 10,
            skip: 0
          },
          filter: {
            searchKey: this.propertySearchKey
          },
          landlordId: this.selectedLandlordId
        }),
        result({ data }) {
          // , loading, networkStatus, refetch
          this.properties = this.$format.cloneVariable(
            data.getPropertyByLandlordForAdmin.properties
          );
          this.loading = false;
        },
        skip() {
          return !this.selectedLandlordId;
        }
      };
    },
    getProperties() {
      return {
        query: require("@/property/api/queries/property/property_query.graphql"),
        fetchPolicy: "no-cache",
        variables: {
          input: {
            limit: 0,
            skip: 0
          },
          filter: {
            searchKey: this.selectedPropertyName
          }
        },
        result({ data }) {
          this.properties = data.getProperties.properties;
          this.totalPropertiesCount = data.getProperties.totalCount;
        }
      };
    }
  }
};
</script>

<style scoped>
/* This is the size of the path of the scrollbar */
#wrapper2 {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}

/* This div allow to make the scroll function and show the scrollbar */
#top-scroll {
  height: 1px;
  overflow: scroll;
}

/* This is the size of the scrollbar */
.width-scroll-top {
  width: 2800px;
}
</style>
